import { UserInfos } from './../interfaces/user-infos';
import { Component, Injectable, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../services/users.service';
import { MangopayService } from '../services/mangopay.service';
import countryIso  from '../../../assets/data/countryIso/countryIso.json';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {

      const date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[0], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}

@Component({
  selector: 'app-user-payment',
  templateUrl: './user-payment.component.html',
  styleUrls: ['./user-payment.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  ]
})
export class UserPaymentComponent implements OnInit {

  	@BlockUI() blockUI: NgBlockUI;
	@Input() id: string;
	@Input() role: string;
	@ViewChild('date')
    date: any;

	countries: Object;
	minDate: Object;
	maxDate: Object;

	typeOfFileAccepted = [
		"application/pdf",
		"image/png",
		"image/jpeg"
	]
	formatInvalid = {
		IDENTITY_PROOF: false,
		ADDRESS_PROOF: false
	}
	fileUpload = {
		IDENTITY_PROOF: null,
		ADDRESS_PROOF: null,
	}


	userInfos: UserInfos = {
		id: "",
		firstName: "",
		lastName: "",
		fullName: "",
		email: "",
		isActive: false,
		idOrganization: "",
		idRole: "",
		role: "",
		lastConnect: "",
		shopName: "",
		image: "",
		description: "",
		isFittingShop: false,
		subDomainName: "",
		isWeb: false,
        isPriseCote: false,
		geolocation: "",
		telephoneNumber: "",
		shopCity: "",
		shopCountry: "",
		shopPostalCode: "",
		shopAddress: "",
		shopAddressSup: "",
		orderProcessing: 0,
		orderFinished: 0,
		network: [],

		providerName: "",
		phone: "",
		logo: "",
		adressCity: "",
		adressCountry: "",
		adressPostalCode: "",
		adressStreet: "",
		adressState: "",
		nbProviderTotal: 0,
		nbOrderRefusee: 0,
		nbProviderSold: 0,

		mangoUserId: "",
		mangoFirstName: "",
		mangoLastName: "",
		mangoEmail: "",
		birthday: null,
		nationality: "",
		residencecountry: "",

		walletId: "",
		IDENTITY_PROOF: {
			id: "",
			raison: "",
			status: ""
		},
		ADDRESS_PROOF: {
			id: "",
			raison: "",
			status: ""
		},

		bankAccountId: "",
		bankAddress1: "",
		bankAddress2: "",
		bankCity: "",
		bankCodepostal: "",
		bankCountry: "",
		bankDetailsIBAN: "FR7630004000031234567890143",
		bankOwnerName: "",

		bankRegion: "",
		bankbIC: "",
	}

	isValidFile: boolean;
	canCreateUser: boolean = true;
	showAccoutBankForm: boolean = false;
	disabledAccoutBankForm: boolean = false;

	constructor(
		public activeModal: NgbActiveModal,
		private toastrService: ToastrService,
		private usersService: UsersService,
		private mangopayService: MangopayService,
	) { }

	ngOnInit(): void {
		this.getUserInfoById();
		this.countries = countryIso;

		// set date picker
		this.minDate = {
			year: new Date().getFullYear() - 100,
			month: 1,
			day: 1
		}
		this.maxDate = {
			year: new Date().getFullYear(),
			month: new Date().getMonth() + 1,
			day: new Date().getDay() + 1
		}
	}

	getUserInfoById(): void {

		this.blockUI.start('Loading');

		this.usersService.getShopDetailById(this.id).subscribe(
			(res) => {
				if (res.success) {

					this.userInfos = res.data as UserInfos;

					if (this.userInfos.birthday) {

						this.userInfos.birthday = {
							"year": parseInt(this.userInfos.birthday.split('-')[0]),
							"month": parseInt(this.userInfos.birthday.split('-')[1]),
							"day": parseInt(this.userInfos.birthday.split('-')[2])
						}
					}

					this.initModal();

					this.blockUI.stop();
				}
				else {

					this.blockUI.stop();

					if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
						this.toastrService.error('Les paramètres sont invalides');

					} else if (res.errorSet.includes('NOTFOUND')) {
						this.toastrService.error('Utilisateur non trouvé');

					} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
						this.toastrService.error('Une erreur serveur est survenue');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}

	initModal(): void {

		// si le compte mangopay est créé
		if (this.userInfos.mangoUserId) {

			this.canCreateUser = false;
			this.showAccoutBankForm = true;

			if (this.userInfos.bankAccountId) {
				this.disabledAccoutBankForm = true;
			}
		}

	}

	async createUserMangopay(): Promise<void> {

		this.blockUI.start('Loading');

		const data = this.getUserForm();

		if (!data) {

			this.blockUI.stop();

			this.date.status === 'INVALID'
				? this.toastrService.error("Veuillez renseigner une date de naissance valide")
				: this.toastrService.error("Veuillez renseigner tout les champs");

			return;
		}

    await this.mangopayService.loadMangopayToken(this.userInfos.network[0]);
		this.mangopayService.createNaturalUser(this.userInfos.network[0], data).subscribe(
			(res) => {
				if (res) {

					this.userInfos.mangoUserId = res.Id;

					this.userInfos.mangoFirstName = res.FirstName;
					this.userInfos.mangoLastName = res.LastName;
					this.userInfos.mangoEmail = res.Email;
					this.userInfos.nationality = res.Nationality;
					this.userInfos.residencecountry = res.CountryOfResidence;

					let birthday = new Date(res.Birthday*1000);
					this.userInfos.birthday = {
						"year": birthday.getFullYear(),
						"month": birthday.getMonth() + 1,
						"day": birthday.getDate()
					}

					this.toastrService.success("Création du compte mangopay");

					this.createWallet();


					this.blockUI.stop();

				} else {

					console.error("create_user_mangopay_error_respons", res);
					this.toastrService.error("Une erreur s'est produite lors de la création du compte mangopay");
					this.blockUI.stop();
				}
			},
			(error) => {
				console.error("error_create_user_mangopay", error);
				this.toastrService.error("Une erreur avec le serveur mangopay s'est produite lors de la création du compte mangopay");
				this.blockUI.stop();
			}
		);
	}

	async updateUserMangopay(): Promise<void> {

		this.blockUI.start('Loading');

		const data = this.getUserForm();

		if (!data) {

			this.blockUI.stop();

			this.date.status === 'INVALID'
				? this.toastrService.error("Veuillez renseigner une date de naissance valide")
				: this.toastrService.error("Veuillez renseigner tout les champs");

			return;
		}

    await this.mangopayService.loadMangopayToken(this.userInfos.network[0]);
		this.mangopayService.updateNaturalUser(this.userInfos.network[0], data, this.userInfos.mangoUserId).subscribe(
			(res) => {
				if (res) {

					this.userInfos.mangoFirstName = res.FirstName;
					this.userInfos.mangoLastName = res.LastName;
					this.userInfos.mangoEmail = res.Email;
					this.userInfos.nationality = res.Nationality;
					this.userInfos.residencecountry = res.CountryOfResidence;

					let birthday = new Date(res.Birthday*1000);
					this.userInfos.birthday = {
						"year": birthday.getFullYear(),
						"month": birthday.getMonth() + 1,
						"day": birthday.getDate()
					}

					this.toastrService.success("Mise à jour des informations du compte mangopay");

					this.addMangopayUserInfoToShop();

					this.blockUI.stop();

				} else {
					this.blockUI.stop();
					console.error("update_user_mangopay_error_respons",res);
					this.toastrService.error("Une erreur s'est produite lors la mise à jour des informations du compte mangopay");
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error("error_updateate_user_mangopay", error);
				this.toastrService.error("Une erreur avec le serveur mangopay s'est produite lors la mise à jour des informations du compte");
			}
		);
	}

	getUserForm(): any {

		if (
			!this.userInfos.birthday
			|| !this.userInfos.mangoFirstName
			|| !this.userInfos.mangoLastName
			|| !this.userInfos.mangoEmail
			|| !this.userInfos.nationality
			|| !this.userInfos.residencecountry
			|| this.date.status === 'INVALID'
		)

		{
			return false;
		}

		const { year, month, day } = this.userInfos.birthday;

		const data = {
			FirstName: this.userInfos.mangoFirstName,
			LastName: this.userInfos.mangoLastName,
			Email: this.userInfos.mangoEmail,
			Birthday: new Date(year+"-"+month+"-"+day).getTime()/1000,
			Nationality: this.userInfos.nationality,
			CountryOfResidence: this.userInfos.residencecountry,
			UserCategory: "Owner"
		}

		return data;
	}

	async createWallet(): Promise<void> {

		this.blockUI.start('Loading');

		const data = {
			Owners: [ this.userInfos.mangoUserId ],
			Description: `portefeuille pour le site ecommerce ${this.userInfos.network[0] === 'SM' ? 'Sur-Mesure Menuisier' : 'Maison du Menuisier'}`,
			Currency: "EUR",
		}

    await this.mangopayService.loadMangopayToken(this.userInfos.network[0]);
		this.mangopayService.createWallet(this.userInfos.network[0], data).subscribe(
			(res) => {
				if (res) {

					this.userInfos.walletId = res.Id;
					this.showAccoutBankForm = true;

					this.addMangopayUserInfoToShop();

					this.blockUI.stop();

				} else {
					this.blockUI.stop();
					console.error("create_wallet_error_respons", res);
					this.toastrService.error("Une erreur s'est produite lors de la creation du protefeuille mangopay");
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error("error_create_wallet", error);
				this.toastrService.error("Une erreur avec le serveur mangopay s'est produite lors de la creation du protefeuille");
			}
		);
	}

	addMangopayUserInfoToShop(): void {

		this.blockUI.start('Loading');

		// call api rmm for add id user & id wallet of mangopay

		const { year, month, day } = this.userInfos.birthday;

		let data = {
			id: this.userInfos.id,
			jwt: localStorage.getItem('token'),
			firstname: this.userInfos.mangoFirstName,
			name: this.userInfos.mangoLastName,
			email: this.userInfos.mangoEmail,
			birthday: `${year}-${month}-${day}`,
			nationality: this.userInfos.nationality,
			residencecountry: this.userInfos.residencecountry,
			userId: this.userInfos.mangoUserId,
			walletId: this.userInfos.walletId
		}


		this.usersService.modifyMangoInfo(data).subscribe(
			(res) => {
				if (res.success) {

					if (this.userInfos.IDENTITY_PROOF.status || this.userInfos.ADDRESS_PROOF.status) {
						this.toastrService.warning("Les demandes de vérification KYC en cours ou validé ont été annulé");
					}

					this.userInfos.IDENTITY_PROOF = res.data.IDENTITY_PROOF;
					this.userInfos.ADDRESS_PROOF = res.data.ADDRESS_PROOF;

					this.canCreateUser = false;

					this.blockUI.stop();
				}
				else {
					this.blockUI.stop();
					console.error("error modify Mango Info", res);
					this.toastrService.error("une erreur s'est produite lors de la sauvegarde des données sur le PIM");
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error("ERROR modify Mango Info", error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		)
	}

	async processFile(event, docType) {

		let isValidFile = document.getElementById('isValidFile_'+docType);
		let isNotValidFile = document.getElementById('isNotValidFile_'+docType);

		isNotValidFile.style.display = "none";
		isValidFile.style.display = "none";

		// init file
		this.fileUpload[docType] = null;


		// init
		this.formatInvalid[docType] = false;

		// si il ajoute un fichier puis qu'il le change et finalement annule
		if (!event.target.files[0]) { return };

		this.formatInvalid[docType] = this.typeOfFileAccepted.includes(event.target.files[0].type) ? false : true;

		if (this.formatInvalid[docType]) { return };

		this.convertFileToBase64(event.target.files[0]).subscribe(base64File => {

			let blob = new Blob([base64File]);

			if (blob.size < 10000000) {

				this.fileUpload[docType] = base64File;

				isValidFile.style.display = "block";

			} else {

				isNotValidFile.style.display = "block";
			}
		});
	}

	convertFileToBase64(file : File) : Observable<string> {
		const result = new ReplaySubject<string>(1);
		const reader = new FileReader();
		reader.readAsBinaryString(file);
		reader.onload = (event) => result.next(btoa(event.target.result.toString()));
		return result;
	}

	async sendKYC(docType): Promise<void> {

		this.blockUI.start('Loading');

		const data = {
			Type: docType,
			Tag: this.userInfos.shopName
		}


    await this.mangopayService.loadMangopayToken(this.userInfos.network[0]);
		this.mangopayService.createKycDocument(this.userInfos.network[0], data, this.userInfos.mangoUserId).subscribe(
			(res) => {

				if (res) {

					this.userInfos[docType].id = res.Id;
					this.createKycPage(docType);

					this.blockUI.stop();

				} else {
					this.blockUI.stop();
					console.error("create_kyc_doc_error_respons", res);
					this.toastrService.error("Une erreur s'est produite lors de la creation du document kyc");
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error("error_kyc_doc", error);
				this.toastrService.error("Une erreur avec le serveur mangopay s'est produite lors de la creation du document kyc");
			}
		);

	}

	async createKycPage(docType: string): Promise<void> {

		this.blockUI.start('Loading');

		const data = {
			File: this.fileUpload[docType]
		}

    await this.mangopayService.loadMangopayToken(this.userInfos.network[0]);
		this.mangopayService.createKycPage(this.userInfos.network[0], data, { userId: this.userInfos.mangoUserId, kycId: this.userInfos[docType].id }).subscribe(
			(res) => {
				this.submitKycDocument(docType);
				this.blockUI.stop();
			},
			(error) => {
				this.blockUI.stop();
				console.error("error_kyc_page", error);
				this.toastrService.error("Une erreur avec le serveur mangopay s'est produite lors de la creation de page kyc");
			}
		);
	}

	async submitKycDocument(docType: string): Promise<void> {
		this.blockUI.start('Loading');

		const data = {
			Status: "VALIDATION_ASKED"
		}

    await this.mangopayService.loadMangopayToken(this.userInfos.network[0]);
		this.mangopayService.submitKycDocument(this.userInfos.network[0], data, { userId: this.userInfos.mangoUserId, kycId: this.userInfos[docType].id }).subscribe(
			(res) => {
				if (res) {

					this.userInfos[docType].id = res.Id;

					this.addKycId(docType);

					this.toastrService.success("La demande de validation du KYC a été envoyé");

					this.blockUI.stop();
				} else {
					this.blockUI.stop();
					console.error("submit_kyc_error_respons", res);
					this.toastrService.error("Une erreur s'est produite lors de la demande de validation du kyc");
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error("error_kyc_submit", error);
				this.toastrService.error("Une erreur avec le serveur mangopay s'est produite lors de la demande de validation du kyc");
			}
		);
	}

	addKycId(docType: string): void {
		// call api rmm for add id KYC

		this.blockUI.start('Loading');

		let data = {
			id: this.userInfos.id,
			jwt: localStorage.getItem('token'),
			[docType]: this.userInfos[docType].id
		}

		this.usersService.modifyKYC(docType, data).subscribe(
			(res) => {
				if (res.success) {

					this.userInfos[docType].status = res.data[docType].status;
					this.blockUI.stop();

				} else {

					this.blockUI.stop();
					console.error("add_kyc_to_PIM_error_respons", res);
					this.toastrService.error("Une erreur s'est produite lors de la sauvegarde du kyc sur le PIM");
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error("error_add_kyc_to_PIM", error);
				this.toastrService.error("Une erreur serveur s'est produite lors de la sauvegarde du kyc sur le PIM");
			}
		);
	}

	async createIbanBankAccount(): Promise<void> {

		this.blockUI.start('Loading');

		const data = {
			OwnerName: this.userInfos.bankOwnerName,
			OwnerAddress: {
				AddressLine1: this.userInfos.bankAddress1,
				AddressLine2: this.userInfos.bankAddress2,
				City: this.userInfos.bankCity,
				PostalCode: this.userInfos.bankCodepostal,
				Country: this.userInfos.bankCountry
			},
			IBAN: this.userInfos.bankDetailsIBAN,
		}

    await this.mangopayService.loadMangopayToken(this.userInfos.network[0]);
		this.mangopayService.createIbanBankAccount(this.userInfos.network[0], data, this.userInfos.mangoUserId).subscribe(
			(res) => {
				if (res) {

					this.disabledAccoutBankForm = true;

					this.userInfos.bankAccountId = res.Id;

					this.addMangopayBankInfoToShop();

					this.toastrService.success("les informations du compte bancaire ont été envoyées");
					this.blockUI.stop();
				} else {

					this.blockUI.stop();

					this.toastrService.error("Une erreur s'est produite lors de l'envoi des informations du compte bancaire");
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error("error_IBAN", error);

				let serverError = true;

				if (error.error.errors.IBAN === 'The value is not a valid IBAN') {
					this.toastrService.error("L'IBAN n'est pas valide");
					serverError = false;
				}

				if (error.error.errors.IBAN.includes('The field IBAN must match the regular expression')) {
					this.toastrService.error("L'IBAN n'est pas valide !");
					serverError = false;
				}

				if (error.error.errors.IBAN === "The IBAN field is required.") {
					this.toastrService.error("Veuillez renseigner l'IBAN");
					serverError = false;
				}

				if (error.error.errors['OwnerAddress.AddressLine1'] === "The field AddressLine1 must match the regular expression '^.{1,255}$'.") {
					this.toastrService.error("Veuillez renseigner une adresse");
					serverError = false;
				}

				if (error.error.errors['OwnerAddress.City'] === "The field City must match the regular expression '^.{1,255}$'.") {
					this.toastrService.error("Veuillez renseigner une ville");
					serverError = false;
				}

				if (error.error.errors.OwnerName === "The OwnerName field is required.") {
					this.toastrService.error("Veuillez renseigner renseigner le nom complet du titulaire du compte bancaire");
					serverError = false;
				}

				if (error.error.errors.PostalCode === "The PostalCode is a required field for this Country") {
					this.toastrService.error("Veuillez renseigner renseigner le code postal");
					serverError = false;
				}

				if (error.error.errors['OwnerAddress.Country'] === "The Country field is required.") {
					this.toastrService.error("Veuillez renseigner renseigner le pays");
					serverError = false;
				}

				if (serverError) {
					this.toastrService.error("Une erreur avec le serveur mangopay s'est produite lors de l'envoi des informations du compte bancaire");
				}
			}
		);
	}

	async deleteBankAccount(): Promise<void> {

		this.blockUI.start('Loading');

    await this.mangopayService.loadMangopayToken(this.userInfos.network[0]);
		this.mangopayService.deactivateBankAccount(this.userInfos.network[0], this.userInfos.bankAccountId, this.userInfos.mangoUserId).subscribe(
			(res) => {
				if (res) {

					this.userInfos.bankAccountId = "";
					this.userInfos.bankOwnerName = "";
					this.userInfos.bankAddress1 = "";
					this.userInfos.bankAddress2 = "";
					this.userInfos.bankCity = "";
					this.userInfos.bankCodepostal = "";
					this.userInfos.bankCountry = "";
					this.userInfos.bankDetailsIBAN = "";

					this.disabledAccoutBankForm = false;

					this.addMangopayBankInfoToShop();

					this.toastrService.success("les informations du compte bancaire ont été supprimé");
					this.blockUI.stop();
				} else {

					this.blockUI.stop();

					this.toastrService.error("Une erreur s'est produite lors de la suppression du compte bancaire");
				}
			},
			(error) => {

				this.blockUI.stop();

				this.toastrService.error("Une erreur s'est produite lors de la suppression du compte bancaire");
			}
		)
	}

	addMangopayBankInfoToShop(): void {

		this.blockUI.start('Loading');

		let data = {
			id: this.userInfos.id,
			jwt: localStorage.getItem('token'),
			bankAccountId: this.userInfos.bankAccountId,
			address1: this.userInfos.bankAddress1,
			address2: this.userInfos.bankAddress2,
			city: this.userInfos.bankCity,
			postalCode: this.userInfos.bankCodepostal,
			country: this.userInfos.bankCountry,
			IBAN: this.userInfos.bankDetailsIBAN,
			ownername: this.userInfos.bankOwnerName,
			region: "",
			bic: "",
		}

		this.usersService.modifyBankInfo(data).subscribe(
			(res) => {
				if (res.success) {

					this.canCreateUser = false;

					this.blockUI.stop();
				}
				else {
					this.blockUI.stop();
					console.error("error modify Mango bank Info", res);
					this.toastrService.error("une erreur s'est produite lors de la sauvegarde des données sur le PIM");
				}
			},
			(error) => {
				this.blockUI.stop();
				console.error("ERROR modify Mango bank Info", error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		)
	}
}
